import React from "react";
import * as Rb from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as Bi from "react-icons/bs";
class about extends React.Component
{
    render(){
        return(
            <div className="top_align mb-2">
                <Rb.Card className="shadow card_align">
                        <Rb.Card.Body>
                            <section>
                                <div className="main_header">
                                    <h2 className="text-white">About Me</h2>
                                </div>
                                
                                <div className="mt-3">
                                    <p className="">I'm a software developer from India,  working in web and Mobile Ui development. I enjoy turning complex problems into simple or finding alternative solution </p>
                                    <p className="">Looking for a challenging role in a reputable organisation to utilise my technical,web design and web
development, and management skills for the growth of the organisation as well as to enhance my
knowledge about new and emerging trends in the IT sector.</p>
                                </div>
                            </section>
                            <section>
                                <div className="sub_heading mt-4">
                                    <h2 className="">What I'm Doing</h2>
                                    <Rb.Row className="">
                                        <Rb.Col sm={12} md={6} lg={6} xl={6} className="py-2">
                                            <Rb.Card className="">
                                                <Rb.Card.Body className="g_box">
                                                    <div className="d-flex">
                                                        <Bi.BsTextareaResize className="about_icon"/>
                                                        <div className="ps-3">
                                                            <h3>Web Ui Developing</h3>
                                                            <p className="mb-0">Developing a quality programming coding and web application</p>
                                                        </div>
                                                    </div>
                                                </Rb.Card.Body>
                                            </Rb.Card>
                                        </Rb.Col>
                                        <Rb.Col sm={12} md={6} lg={6} xl={6} className="py-2">
                                            <Rb.Card>
                                                <Rb.Card.Body className="g_box">
                                                    <div className="d-flex">
                                                        <Bi.BsTextareaResize className="about_icon"/>
                                                        <div className="ps-3">
                                                            <h3>Mobile Ui Developing</h3>
                                                            <p className="mb-0">Developing a quality programming coding and Mobile application</p>
                                                        </div>
                                                        
                                                    </div>
                                                </Rb.Card.Body>
                                            </Rb.Card>
                                        </Rb.Col>
                                        <Rb.Col sm={12} md={6} lg={6} xl={6} className="py-2">
                                            <Rb.Card>
                                                <Rb.Card.Body className="g_box">
                                                    <div className="d-flex">
                                                        <Bi.BsTextareaResize className="about_icon"/>
                                                        <div className="ps-3">
                                                            <h3>Wordpress Developing</h3>
                                                            <p className="mb-0">The most modern and high-quality design and Developing a website</p>
                                                        </div>
                                                        
                                                    </div>
                                                </Rb.Card.Body>
                                            </Rb.Card>
                                        </Rb.Col>
                                        <Rb.Col sm={12} md={6} lg={6} xl={6} className="py-2">
                                            <Rb.Card>
                                                <Rb.Card.Body className="g_box">
                                                    <div className="d-flex">
                                                        <Bi.BsTextareaResize className="about_icon"/>
                                                        <div className="ps-3">
                                                            <h3>Figma Design</h3>
                                                            <p className="mb-0">The most modern and high-quality design</p>
                                                        </div>
                                                    </div>
                                                </Rb.Card.Body>
                                            </Rb.Card>
                                        </Rb.Col>
                                    </Rb.Row>
                                </div>
                            </section>
                            <section>
                                <div className="sub_heading mt-4">
                                    <h2 className="">My Extra Activies</h2>
                                    <Rb.Row className="mt-5">
                                        <Rb.Col sm={12} md={6} lg={6} xl={6} className="py-2">
                                            <Rb.Card>
                                                <Rb.Card.Body className="g_box">
                                                    <div className="text-center position-relative">
                                                        <div className="d-flex active_ali">
                                                            <span className="box_2  box_gray  shadow text-center">
                                                                <Bi.BsGift className="profile_icon y_color"/>
                                                            </span>
                                                        </div>
                                                        <div className="">
                                                            <h3>Design and Print Initation Card</h3>
                                                            <p className="mb-0">The most modern and high-quality design made at a professional level.</p>
                                                        </div>
                                                    </div>
                                                </Rb.Card.Body>
                                            </Rb.Card>
                                        </Rb.Col>
                                      
                                    </Rb.Row>
                                </div>
                            </section>
                        </Rb.Card.Body>
                    </Rb.Card>  
            </div>
        )
    }
}
export default about